import PaycomReaderNode from './types/paycom-reader';
import PaycomWriterNode from './types/paycom-writer';

export const paycomNodes = {
  paycomReader: PaycomReaderNode,
  paycomWriter: PaycomWriterNode,
};
